import type { SVGProps } from "react";
export interface HeartPulseIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HeartPulseIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HeartPulseIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.026 9.375c.475.01.891.319 1.041.769l1.244 3.731h3.06l.116.006a1.124 1.124 0 0 1 0 2.238l-.116.006h-3.87c-.484 0-.915-.31-1.068-.769l-.51-1.526-1.372 3.574a1.125 1.125 0 0 1-2.057.1l-1.245-2.49-.243.488c-.19.381-.58.623-1.005.623H4.626a1.125 1.125 0 0 1 0-2.25h2.68l.938-1.878.08-.136a1.126 1.126 0 0 1 1.933.136l1.109 2.218 1.585-4.12.074-.158a1.13 1.13 0 0 1 1-.562Z"
      />
      <path
        fill={color}
        d="M16.898 2.875c1.748 0 3.337.902 4.45 2.177 1.117 1.28 1.834 3.022 1.774 4.867-.084 2.768-1.94 4.912-3.739 6.671a258 258 0 0 1-4.712 4.486 3.92 3.92 0 0 1-5.05.247l-.292-.246c-.917-.85-2.097-1.958-3.39-3.202L4.613 16.59C2.815 14.832.96 12.687.875 9.92l-.001-.345c.033-1.717.728-3.323 1.775-4.523C3.76 3.777 5.352 2.875 7.1 2.875c2.484 0 3.996 1.277 4.897 2.47.9-1.193 2.414-2.47 4.9-2.47Zm0 2.25c-2.114 0-3.113 1.421-3.671 2.484l-.216.43-.001.002q-.007.013-.013.025a1 1 0 0 1-.12.185 1 1 0 0 1-.104.11l-.056.051a1.1 1.1 0 0 1-.227.154 1.1 1.1 0 0 1-.284.086 1.1 1.1 0 0 1-.321.015 1 1 0 0 1-.094-.015 1.1 1.1 0 0 1-.283-.086 1.1 1.1 0 0 1-.228-.152q-.032-.029-.063-.059a1.1 1.1 0 0 1-.175-.212l-.04-.074-.015-.028-.002-.002c-.51-1.057-1.469-2.914-3.884-2.914-.961 0-1.972.506-2.757 1.406-.732.84-1.198 1.946-1.22 3.087l.001.228v.003l.023.333c.183 1.654 1.35 3.148 3.039 4.8a247 247 0 0 0 4.67 4.444l.127.106a1.67 1.67 0 0 0 2.158-.106 251 251 0 0 0 4.668-4.444c1.801-1.762 3.01-3.345 3.063-5.133v-.003l.002-.228c-.023-1.141-.49-2.248-1.222-3.087-.785-.9-1.795-1.406-2.755-1.406"
      />
    </svg>
  );
}
